import React from 'react';
import { CheckCircle } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1703226741497-6de4f67c6e11?w=800&h=500&fit=crop&auto=format"
              alt="Maritime Port Operations"
              className="w-full h-[500px] object-cover rounded-lg"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
          </div>
          
          {/* Right - Content */}
          <div className="space-y-8">
            <h2 className="display-large text-white">
              Dedicated To Maritime Excellence
            </h2>
            
            <p className="body-large text-text-secondary">
              We are committed to digitizing maritime assets and ensuring compliance with 2050 energy regulations. Our expertise spans vessel management, predictive analytics, and sustainable shipping solutions.
            </p>
            
            {/* Benefits Grid */}
            <div className="flex items-center gap-3">
              <CheckCircle className="text-brand-primary" size={20} />
              <span className="body-medium text-text-primary">24/7 Expert Support, Supervisory and Solution</span>
            </div>
            
            <div className="grid grid-cols-2 gap-8 pt-8">
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1594110336951-5bc8c12d6b27?w=400&h=128&fit=crop&auto=format"
                  alt="Container Ship Analytics"
                  className="w-full h-32 object-cover rounded-lg"
                  loading="lazy"
                />
                <p className="body-small text-text-muted mt-2">Advanced Analytics</p>
              </div>
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1631844920380-e7cd70ed5032?w=400&h=128&fit=crop&auto=format"
                  alt="Vessel Operations"
                  className="w-full h-32 object-cover rounded-lg"
                  loading="lazy"
                />
                <p className="body-small text-text-muted mt-2">Vessel Operations</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;